import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=c9dd764e&scoped=true&"
import script from "./Cards.vue?vue&type=script&lang=ts&"
export * from "./Cards.vue?vue&type=script&lang=ts&"
import style0 from "./Cards.vue?vue&type=style&index=0&id=c9dd764e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dd764e",
  null
  
)

export default component.exports